import { IComment } from "./icomment.interface";
import moment from "moment";

export function formatCommentDate(comment: IComment): string {
  return `${moment(comment.posted).format("MMM DD, YYYY")} at ${moment(comment.posted).format(
    "h:mm"
  )} ${moment(comment.posted).hours() >= 12 ? "PM" : "AM"}`;
}
